export const normalizeRole = (role?: string) => {
  if (!role) return 'user';
  const normalized = role.trim().toLowerCase().replace(/\s+/g, '_');

  if (
    normalized === 'admin' ||
    normalized === 'administrador' ||
    normalized === 'administrador_general' ||
    normalized === 'administradorgeneral'
  ) {
    return 'admin';
  }

  if (
    normalized === 'operator' ||
    normalized === 'operador' ||
    normalized === 'cargador_datos' ||
    normalized === 'cargador_de_datos'
  ) {
    return 'operador';
  }

  if (
    normalized === 'auditor' ||
    normalized === 'auditor_interno'
  ) {
    return 'auditor';
  }

  if (
    normalized.includes('gestor') ||
    normalized === 'manager'
  ) {
    return 'gestor';
  }

  return normalized;
};

export const formatRoleLabel = (role?: string) => {
  const normalized = normalizeRole(role);

  if (normalized === 'admin') {
    return 'Administrador';
  }
  if (normalized === 'operador' || normalized === 'operator') {
    return 'Cargador de Datos';
  }

  if (normalized === 'gestor') {
    return 'Gestor de Indicadores';
  }

  if (!normalized) return 'Usuario';
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
};
